module.exports = __webpack_public_path__ + "static/media/the_interworld.3cca1f13.jpg";